import useTypedSelector from "./useTypedSelector";
import {emptyUser} from "../models/User";

const useCurrentUser = () => useTypedSelector(s => s.auth.currentUser ?? emptyUser);

export default useCurrentUser;
